import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ArticlePerformanceFragment = { id: string, entityId: string, userId: string, progress: number, status: Types.PerformanceStatusEnum, isAvailable: boolean, points?: number | null, enrolmentInfo?: { dripSettings?: { type: Types.DripTypeEnum, dripBy?: Types.DripByEnum | null, interval?: number | null } | null } | null, userBadges: Array<{ awardId: string, entityId: string, id: string }> };


export type ArticlePerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ArticlePerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ArticlePerformance on ArticlePerformanceType {
  id
  entityId
  userId
  progress
  status
  isAvailable
  enrolmentInfo {
    dripSettings {
      type
      dripBy
      interval
    }
  }
  points
  userBadges {
    awardId
    entityId
    id
  }
}
    `;